import type { ManifestEntry } from "../instrument.js";
import * as sampleCansComprehensive_1_0_r1 from "./sample-cans/comprehensive-1-0-r1.js";
import * as sampleCansComprehensive_1_0_r2 from "./sample-cans/comprehensive-1-0-r2.js";
import * as sampleCansComprehensive_1_0_r3 from "./sample-cans/comprehensive-1-0-r3.js";
import * as sampleCansMini_1_0_r1 from "./sample-cans/mini-1-0-r1.js";
import * as sampleCansMini_1_0_r2 from "./sample-cans/mini-1-0-r2.js";
import * as sampleCore_1_0_r1 from "./sample/core-1-0-r1.js";
import * as sampleCore_1_1_r1 from "./sample/core-1-1-r1.js";
import * as sampleCore_1_2_r1 from "./sample/core-1-2-r1.js";

/**
 * Every published instrument version, in the order it was published.
 *
 * A module says what an instrument *is*. This says that it was published, what
 * it digested to at the moment it was, and which version it followed — facts
 * about publishing, which constrain what may be authored next and change
 * nothing about what a document means. Keeping them here rather than in the
 * module is what lets the module be read as the instrument alone.
 *
 * The digests are written by `pnpm instruments:pin` and never by hand. A new
 * entry carries `digest: UNPINNED` until the pin fills it in; the pin refuses
 * to rewrite one it has already filled, and the pin test recomputes every one,
 * so a published schema that is edited fails the suite rather than quietly
 * becoming a different instrument under the same name. Publishing is: write the
 * module, add the entry, run the pin, commit both halves.
 *
 * An entry is appended, never rewritten. A change to a published version is a
 * new version with a new name.
 */
export const manifest: readonly ManifestEntry[] = [
  {
    module: sampleCore_1_0_r1,
    digest:
      "sha256:a5845fd5f29253df809ca2d820215974ed6542e271087418227a4dc47f6c646e",
    predecessor: null,
  },
  {
    module: sampleCore_1_1_r1,
    digest:
      "sha256:8887461cb998a31b8e656f671a8058b48f55e2fc4e7b55203a5d243eb8d976f9",
    predecessor: "sample/core/1.0/r1",
  },
  {
    module: sampleCansComprehensive_1_0_r1,
    digest:
      "sha256:a3a616b8f33a0a6a5b66ee4bce6c9492734bf4c762815f35fa1067109d9e13ab",
    predecessor: null,
  },
  {
    module: sampleCore_1_2_r1,
    digest:
      "sha256:f6b97920e9bdcaecf6b02316dfa69ccb2ffe52995304e8abe4674c1b07d28b60",
    predecessor: "sample/core/1.1/r1",
  },
  {
    module: sampleCansComprehensive_1_0_r2,
    digest:
      "sha256:b9757be2f62bb0c329b6bd3aa78241358693aeed62528397ccc713a6d3d47720",
    predecessor: "sample_cans/comprehensive/1.0/r1",
  },
  {
    module: sampleCansMini_1_0_r1,
    digest:
      "sha256:70adf98ea6072bba444deb534e850905f1281584dc5a9e1693106e9d42916167",
    predecessor: null,
  },
  {
    module: sampleCansComprehensive_1_0_r3,
    digest:
      "sha256:9468c23c14ae796c33b50d741f89f69bc965845bd636c8de9af7f3c5377341bc",
    predecessor: "sample_cans/comprehensive/1.0/r2",
  },
  {
    module: sampleCansMini_1_0_r2,
    digest:
      "sha256:de7d1955143285561452134ab3fe1d41c087463ab042494212af8a7f66768f5a",
    predecessor: "sample_cans/mini/1.0/r1",
  },
];
